import React from "react"
import s from "./SecondaryFeatures.module.scss"
import cx from "classnames"

import Logo from "assets/images/dogmented/logo.svg"
import PetfinderLogo from "assets/images/dogmented/petfinder-logo.svg"

export default function SecondaryFeatures(props) {
  return (
    <>
      <div className={s.feature}>
        <hr />
        <img src={Logo} alt="Kia" className={s.logo} />
        <p>Introducing the all-electric Kia EV6.</p>
        <a
          href="https://www.kia.com/us/en/ev6"
          rel="noreferrer"
          className="exploreKia"
          target="_blank"
        >
          Learn More
        </a>
      </div>
      <div className={cx(s.feature, s.alt)}>
        <div>
          <img src={PetfinderLogo} alt="Kia" className={s.logo} />
        </div>
        <a
          href="https://petfinderfoundation.com/kia"
          className="adopt"
          rel="noreferrer"
          target="_blank"
        >
          Adopt Today
        </a>
      </div>
    </>
  )
}
